import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

// この部分を Web から取得したキーへと変更してください。
const config = {
  apiKey: 'AIzaSyAJseO7BYQPbw_AETMmzzfS2KMwXueI6Gs',
  authDomain: 'oh-my-jslounge-vue-sample.firebaseapp.com',
  databaseURL: 'https://oh-my-jslounge-vue-sample.firebaseio.com',
  projectId: 'oh-my-jslounge-vue-sample',
  storageBucket: 'oh-my-jslounge-vue-sample.appspot.com',
  messagingSenderId: '618543189895'
}
const settings = { timestampsInSnapshots: true }

firebase.initializeApp(config)

Vue.use(Vuex)
Vue.prototype.$firebase = firebase

// 以下は Firebase の初期化後に Vuex ストアを生成するためのコードです。
async function createStore() {
  await firebase.auth()
  const database = await firebase.firestore()
  database.settings(settings)
  return new Vuex.Store({
    state: {
      isLoggedIn: false,
      database
    },
    getters: {
      isLoggedIn: state => state.isLoggedIn
    },
    mutations: {
      login(state) {
        state.isLoggedIn = true
      }
    },
    actions: {
      async login({ commit }) {
        commit('login')
      }
    }
  })
}
export default createStore
